// import { useQuery } from "@tanstack/react-query";
// import AppLayout from "../../../components/Layout";
// import { getDailyRecoveryReport, getSummaryPreIntervention } from "../../../services/adminController";
// import { Table, TableColumnsType ,Button, Card,} from "antd";
// import LabelText from "../../../components/LabelText";
// import { useParams } from "react-router-dom";
// import { formatRupee } from "../../../utils";

// interface DRRData {
//   bucket: string;
//   cohortName: string | null;
//   totalBorrowers: string;
//   totalOSAmount: string;
//   totalTargetAmount: string | null;
//   forTheDay: string;
//   monthTillDate: string;
//   totalLogin: string;
//   totalConnect1600: string;
//   totalConnectNon1600: string;
//   totalConnect1600Per: string;
//   totalConnectNon1600Per: string;
//   ptp: string;
//   churn1600: string;
//   churnNon1600: string;
//   averageCaseResource: string;
//   targetAmount: string;
//   totalConnectedCallMade: string;
//   agentCallMade: string;
//   dialerCallMade: string;
//   ivrCallMade: string;
//   emailSent: string;
//   smsSent: string;
//   totalLegalNotice: string | null;
//   todayTargetAmount: string;
//   createdAt: string | null;
//   updatedAt: string | null;
// }


// const DRR=()=>{
//     const payload = {
//     clientId: "nbfc3",
//     date: "28/09/2026",
//     stage: "STAGE_3",
//     status: "ALL",
//   };
// const { lenderId } = useParams<{ lenderId: string }>();
//   const {
//     data: dailyRecoveryReport,
//     isLoading,
//     isError,
//   } = useQuery({
//     queryKey: ["dailyRecoveryReport", payload],
//     queryFn: () => getDailyRecoveryReport(payload),
//   });

  
//  const { data, } = useQuery({
//     queryKey: ["summaryPreIntervention", lenderId],
//     queryFn: () => getSummaryPreIntervention(lenderId || ""),
//     // staleTime: 5 * 60 * 1000, // optional: 5 min cache
//   });

//  const summary_Data = isError ? {} : data?.data || {};
// const isFirstTimeUpload = !summary_Data?.lastUpdated;

// const nextUploadDate = summary_Data?.lastUpdated
//   ? new Date(
//       new Date(summary_Data.lastUpdated).setDate(
//         new Date(summary_Data.lastUpdated).getDate() + 30
//       )
//     )
//   : null;

// const drrTableColumns: TableColumnsType<DRRData> = [
//   {
//     title: "Bucket",
//     dataIndex: "bucket",
//     key: "bucket",
//   },
//   {
//     title: "Total Borrowers",
//     dataIndex: "totalBorrowers",
//     key: "totalBorrowers",
//   },
//   {
//     title: "Total OS Amount",
//     dataIndex: "totalOSAmount",
//     key: "totalOSAmount",
//   },
//   {
//     title: "Target Amount",
//     dataIndex: "targetAmount",
//     key: "targetAmount",
//   },
//   {
//     title: "Today Target Amount",
//     dataIndex: "todayTargetAmount",
//     key: "todayTargetAmount",
//   },
//   {
//     title: "For The Day",
//     dataIndex: "forTheDay",
//     key: "forTheDay",
//   },
//   {
//     title: "Month Till Date",
//     dataIndex: "monthTillDate",
//     key: "monthTillDate",
//   },
//   {
//     title: "Total Login",
//     dataIndex: "totalLogin",
//     key: "totalLogin",
//   },
//   {
//     title: "Connect 1600",
//     dataIndex: "totalConnect1600",
//     key: "totalConnect1600",
//   },
//   {
//     title: "Connect Non 1600",
//     dataIndex: "totalConnectNon1600",
//     key: "totalConnectNon1600",
//   },
//   {
//     title: "Connect 1600 %",
//     dataIndex: "totalConnect1600Per",
//     key: "totalConnect1600Per",
//   },
//   {
//     title: "Connect Non 1600 %",
//     dataIndex: "totalConnectNon1600Per",
//     key: "totalConnectNon1600Per",
//   },
//   {
//     title: "PTP",
//     dataIndex: "ptp",
//     key: "ptp",
//   },
//   {
//     title: "Churn 1600",
//     dataIndex: "churn1600",
//     key: "churn1600",
//   },
//   {
//     title: "Churn Non 1600",
//     dataIndex: "churnNon1600",
//     key: "churnNon1600",
//   },
//   {
//     title: "Avg Case Resource",
//     dataIndex: "averageCaseResource",
//     key: "averageCaseResource",
//   },
//   {
//     title: "Total Connected Calls",
//     dataIndex: "totalConnectedCallMade",
//     key: "totalConnectedCallMade",
//   },
//   {
//     title: "Agent Calls",
//     dataIndex: "agentCallMade",
//     key: "agentCallMade",
//   },
//   {
//     title: "Dialer Calls",
//     dataIndex: "dialerCallMade",
//     key: "dialerCallMade",
//   },
//   {
//     title: "IVR Calls",
//     dataIndex: "ivrCallMade",
//     key: "ivrCallMade",
//   },
//   {
//     title: "Email Sent",
//     dataIndex: "emailSent",
//     key: "emailSent",
//   },
//   {
//     title: "SMS Sent",
//     dataIndex: "smsSent",
//     key: "smsSent",
//   },
//   {
//     title: "Legal Notice",
//     dataIndex: "totalLegalNotice",
//     key: "totalLegalNotice",
//   },
// ];

//   console.log(dailyRecoveryReport,"dailyRecoveryReport")
//     return (
//          <AppLayout >

//          <Card title="Summary" className="my-5">
//   <div className="grid grid-cols-3 gap-4">

//     {/* Basic Information */}
//     <LabelText
//       label="Lender Name"
//       text={summary_Data?.lenderName ?? "NA"}
//     />

//     <LabelText
//       label="Last Updated Date (Pre-Intervention)"
//       text={
//         summary_Data?.lastUpdated
//           ? new Date(summary_Data.lastUpdated).toLocaleString("en-IN", {
//               day: "2-digit",
//               month: "2-digit",
//               year: "numeric",
//               hour: "2-digit",
//               minute: "2-digit",
//               second: "2-digit",
//               hour12: true,
//               timeZone: "Asia/Kolkata",
//             })
//           : "NA"
//       }
//     />

//     <LabelText
//       label="Pre-Intervention Re-Upload Date"
//       text={
//         summary_Data?.lastUpdated
//           ? new Date(
//               new Date(summary_Data.lastUpdated).setDate(
//                 new Date(summary_Data.lastUpdated).getDate() + 30
//               )
//             ).toLocaleString("en-IN", {
//               day: "2-digit",
//               month: "2-digit",
//               year: "numeric",
//             })
//           : "NA"
//       }
//     />

//     {/* Overall Collection / Borrower Data */}
//     <LabelText
//       label="Total Borrowers (All Time)"
//       text={summary_Data?.totalBorrowerCount ?? "NA"}
//     />

//     <LabelText
//       label="Total Original Principal (All Time)"
//       text={formatRupee(summary_Data?.totalLoanAmount) ?? "NA"}
//     />

//     <LabelText
//       label="Total Outstanding (All Time)"
//       text={formatRupee(summary_Data?.totalOSAmount) ?? "NA"}
//     />

//     <LabelText
//       label="Total Outstanding (Pre-Intervention)"
//       text={formatRupee(summary_Data?.preInteOSAmount) ?? "NA"}
//     />

//     <LabelText
//       label="Total Pre-Intervention Borrowers"
//       text={summary_Data?.preInteBorrowerCount ?? "NA"}
//     />

//     <LabelText
//       label="Pre-Intervention Loan Amount"
//       text={formatRupee(summary_Data?.preInteLoanAmount) ?? "NA"}
//     />

//     {/* Collection / Target */}
//     <LabelText
//       label="Month-to-Date (MTD) Collection"
//       text={formatRupee(summary_Data?.mtdTotal) ?? "NA"}
//     />

//     <LabelText
//       label="Monthly Target Amount"
//       text={formatRupee(summary_Data?.targetAmount) ?? "NA"}
//     />

//     <LabelText
//       label="Monthly Target Achieved"
//       text={
//         summary_Data?.targetAchievePer !== undefined
//           ? `${summary_Data.targetAchievePer} %`
//           : "NA"
//       }
//     />

//     <LabelText
//       label="Next Allocation Date"
//       text={summary_Data?.nextAllocationDate ?? "NA"}
//     />

//     {/* Bucket-wise Target */}
//     <LabelText
//       label="Target Amount (180-365 Days)"
//       text={formatRupee(summary_Data?.targetAmount_180_365) ?? "NA"}
//     />

//     <LabelText
//       label="Target Amount (365+ Days)"
//       text={formatRupee(summary_Data?.targetAmount_365_plus) ?? "NA"}
//     />

//     {/* Login Counts */}
//     <LabelText
//       label="Login Count (180-365 Days)"
//       text={summary_Data?.loginCount_180_365 ?? "NA"}
//     />

//     <LabelText
//       label="Login Count (365+ Days)"
//       text={summary_Data?.loginCount_365_plus ?? "NA"}
//     />

//     {/* Call Data */}
//     <LabelText
//       label="Total IVR Calls Made"
//       text={summary_Data?.totalIvrCallMade ?? "NA"}
//     />

//     <LabelText
//       label="Agent 1600 Calls (365+ Days)"
//       text={summary_Data?.total_agent_1600_call_365_plus ?? "NA"}
//     />

//     <LabelText
//       label="Agent Calls (365+ Days)"
//       text={summary_Data?.totalAgentCall_365_plus ?? "NA"}
//     />

//     <LabelText
//       label="Agent 1600 Calls (180-365 Days)"
//       text={summary_Data?.totalAgent1600_Call_180_365 ?? "NA"}
//     />

//     <LabelText
//       label="Agent Calls (180-365 Days)"
//       text={summary_Data?.totalAgentCall_180_365 ?? "NA"}
//     />

//     {/* PTP */}
//     <LabelText
//       label="PTP"
//       text={summary_Data?.ptp ?? "NA"}
//     />

//     {/* Actions */}
//     <div className="flex justify-between items-end">
//       {/* <Button
//         type="primary"
//         className="ml-1"
//         onClick={handleOpenModal}
//       >
//         Update Target Amount
//       </Button> */}

//       <Button
//      type="primary"
//       >
//        Update
//       </Button>
//     </div>

//     {/* <UpdateSummaryModal
//       open={isModalOpen}
//       onCancel={handleCloseModal}
//       initialData={modalInitialData}
//       onSubmit={handleSubmitSummary}
//     /> */}

//   </div>
// </Card>



//         <div>
//             Drr reports
//               <Table
//           loading={isLoading}
//           columns={drrTableColumns}
//          dataSource={dailyRecoveryReport?.data?.DRR || []}
//           rowKey={(record) => record.bucket}
//           size="middle"
//           pagination={false}
//           scroll={{ x: 2500 }}
//         />
//         </div>
//         </AppLayout>
//     )
// }

// export default DRR;





// import { useMemo, useState } from "react";
// import { useQuery } from "@tanstack/react-query";
// import { Alert, Button, Card, DatePicker, Select, Table } from "antd";
// import type { TableColumnsType } from "antd";
// import type { ColumnType } from "antd/es/table";
// import dayjs, { Dayjs } from "dayjs";
// import { useParams } from "react-router-dom";
// import AppLayout from "../../../components/Layout";
// import LabelText from "../../../components/LabelText";
// import {
//   getDailyRecoveryReport,
//   getSummaryPreIntervention,
// } from "../../../services/adminController";
// import { formatRupee } from "../../../utils";
// import axios from "axios";

// /* ----------------------------- Types ----------------------------- */

// interface DRRData {
//   bucket: string;
//   cohortName: string | null;
//   totalBorrowers: string;
//   totalOSAmount: string;
//   totalTargetAmount: string | null;
//   forTheDay: string;
//   monthTillDate: string;
//   totalLogin: string;
//   totalConnect1600: string;
//   totalConnectNon1600: string;
//   totalConnect1600Per: string;
//   totalConnectNon1600Per: string;
//   ptp: string;
//   churn1600: string;
//   churnNon1600: string;
//   averageCaseResource: string;
//   targetAmount: string;
//   totalConnectedCallMade: string;
//   agentCallMade: string;
//   dialerCallMade: string;
//   ivrCallMade: string;
//   emailSent: string;
//   smsSent: string;
//   totalLegalNotice: string | null;
//   todayTargetAmount: string;
//   createdAt: string | null;
//   updatedAt: string | null;
// }

// interface SummaryData {
//   lenderName: string;
//   lastUpdated: string;
//   totalBorrowerCount: number | string;
//   totalLoanAmount: number | string;
//   totalOSAmount: number | string;
//   preInteOSAmount: number | string;
//   preInteBorrowerCount: number | string;
//   preInteLoanAmount: number | string;
//   mtdTotal: number | string;
//   targetAmount: number | string;
//   targetAchievePer: number | string;
//   nextAllocationDate: string;
//   targetAmount_180_365: number | string;
//   targetAmount_365_plus: number | string;
//   loginCount_180_365: number | string;
//   loginCount_365_plus: number | string;
//   totalIvrCallMade: number | string;
//   total_agent_1600_call_365_plus: number | string;
//   totalAgentCall_365_plus: number | string;
//   totalAgent1600_Call_180_365: number | string;
//   totalAgentCall_180_365: number | string;
//   ptp: number | string;
// }

// /* ----------------------------- Helpers ----------------------------- */

// const NA = "NA";
// const DATE_FORMAT = "DD/MM/YYYY";
// // TODO: replace with the real client id (route param / auth context)
// const CLIENT_ID = "nbfc3";

// const toNumber = (v: unknown): number | null => {
//   if (v === null || v === undefined || v === "") return null;
//   const n = Number(v);
//   return Number.isNaN(n) ? null : n;
// };

// const rupee = (v: unknown): string => {
//   const n = toNumber(v);
//   return n === null ? NA : String(formatRupee(n));
// };

// const plain = (v: unknown): string =>
//   v === null || v === undefined || v === "" ? NA : String(v);

// const percent = (v: unknown): string => {
//   const n = toNumber(v);
//   return n === null ? NA : `${n} %`;
// };

// const formatDateTime = (v?: string | null) =>
//   v ? dayjs(v).format("DD/MM/YYYY hh:mm:ss A") : NA;

// const formatDate = (v?: string | null) => (v ? dayjs(v).format(DATE_FORMAT) : NA);

// const addDays = (v: string | null | undefined, days: number) =>
//   v ? dayjs(v).add(days, "day").format(DATE_FORMAT) : NA;

// /* ------------------------- Summary fields ------------------------- */

// const buildSummaryFields = (s: Partial<SummaryData>) => [
//   // Basic information
//   { label: "Lender Name", value: plain(s.lenderName) },
//   { label: "Last Updated Date (Pre-Intervention)", value: formatDateTime(s.lastUpdated) },
//   { label: "Pre-Intervention Re-Upload Date", value: addDays(s.lastUpdated, 30) },

//   // Overall collection / borrower data
//   { label: "Total Borrowers (All Time)", value: plain(s.totalBorrowerCount) },
//   { label: "Total Original Principal (All Time)", value: rupee(s.totalLoanAmount) },
//   { label: "Total Outstanding (All Time)", value: rupee(s.totalOSAmount) },
//   { label: "Total Outstanding (Pre-Intervention)", value: rupee(s.preInteOSAmount) },
//   { label: "Total Pre-Intervention Borrowers", value: plain(s.preInteBorrowerCount) },
//   { label: "Pre-Intervention Loan Amount", value: rupee(s.preInteLoanAmount) },

//   // Collection / target
//   { label: "Month-to-Date (MTD) Collection", value: rupee(s.mtdTotal) },
//   { label: "Monthly Target Amount", value: rupee(s.targetAmount) },
//   { label: "Monthly Target Achieved", value: percent(s.targetAchievePer) },
//   { label: "Next Allocation Date", value: plain(s.nextAllocationDate) },

//   // Bucket-wise target
//   { label: "Target Amount (180-365 Days)", value: rupee(s.targetAmount_180_365) },
//   { label: "Target Amount (365+ Days)", value: rupee(s.targetAmount_365_plus) },

//   // Login counts
//   { label: "Login Count (180-365 Days)", value: plain(s.loginCount_180_365) },
//   { label: "Login Count (365+ Days)", value: plain(s.loginCount_365_plus) },

//   // Call data
//   { label: "Total IVR Calls Made", value: plain(s.totalIvrCallMade) },
//   { label: "Agent 1600 Calls (365+ Days)", value: plain(s.total_agent_1600_call_365_plus) },
//   { label: "Agent Calls (365+ Days)", value: plain(s.totalAgentCall_365_plus) },
//   { label: "Agent 1600 Calls (180-365 Days)", value: plain(s.totalAgent1600_Call_180_365) },
//   { label: "Agent Calls (180-365 Days)", value: plain(s.totalAgentCall_180_365) },

//   // PTP
//   { label: "PTP", value: plain(s.ptp) },
// ];

// /* --------------------------- Table columns --------------------------- */

// type ColumnKind = "text" | "amount" | "percent";

// const col = (
//   title: string,
//   key: keyof DRRData,
//   kind: ColumnKind = "text",
//   width = 150
// ): ColumnType<DRRData> => ({
//   title,
//   dataIndex: key,
//   key,
//   width,
//   align: kind === "text" ? undefined : "right",
//   sorter: (a, b) => (toNumber(a[key]) ?? 0) - (toNumber(b[key]) ?? 0),
//   render: (v) =>
//     kind === "amount" ? rupee(v) : kind === "percent" ? percent(v) : plain(v),
// });

// // Defined once, outside the component, so it isn't rebuilt on every render.
// const drrTableColumns: TableColumnsType<DRRData> = [
//   {
//     title: "Bucket",
//     dataIndex: "bucket",
//     key: "bucket",
//     fixed: "left",
//     width: 140,
//     sorter: (a : any, b :any) => a.bucket.localeCompare(b.bucket),
//   },
//   col("Total Borrowers", "totalBorrowers"),
//   col("Total OS Amount", "totalOSAmount", "amount", 170),
//   col("Target Amount", "targetAmount", "amount", 170),
//   col("Today Target Amount", "todayTargetAmount", "amount", 170),
//   col("For The Day", "forTheDay", "amount"),
//   col("Month Till Date", "monthTillDate", "amount"),
//   col("Total Login", "totalLogin"),
//   col("Connect 1600", "totalConnect1600"),
//   col("Connect Non 1600", "totalConnectNon1600"),
//   col("Connect 1600 %", "totalConnect1600Per", "percent"),
//   col("Connect Non 1600 %", "totalConnectNon1600Per", "percent"),
//   col("PTP", "ptp"),
//   col("Churn 1600", "churn1600"),
//   col("Churn Non 1600", "churnNon1600"),
//   col("Avg Case Resource", "averageCaseResource"),
//   col("Total Connected Calls", "totalConnectedCallMade"),
//   col("Agent Calls", "agentCallMade"),
//   col("Dialer Calls", "dialerCallMade"),
//   col("IVR Calls", "ivrCallMade"),
//   col("Email Sent", "emailSent"),
//   col("SMS Sent", "smsSent"),
//   col("Legal Notice", "totalLegalNotice"),
// ];

// const STAGE_OPTIONS = [
//   { value: "STAGE_1", label: "Stage 1" },
//   { value: "STAGE_2", label: "Stage 2" },
//   { value: "STAGE_3", label: "Stage 3" },
// ];
// export const updateSummary = async (clientId: string, payload: UpdateSummaryPayload) => {
//   const response = await axios.post(
//     "/v1/analysis/summary-update",
//     payload,
//     { params: { clientId } }
//   );
//   return response.data;
// };
// /* ----------------------------- Component ----------------------------- */

// const DRR = () => {
//   const { lenderId } = useParams<{ lenderId: string }>();

//   // Filters that drive the DRR request
//   const [date, setDate] = useState<Dayjs>(dayjs());
//   const [stage, setStage] = useState<string>("STAGE_3");

//   const payload = useMemo(
//     () => ({
//       clientId: CLIENT_ID,
//       date: date.format(DATE_FORMAT),
//       stage,
//       status: "ALL",
//     }),
//     [date, stage]
//   );

//   const {
//     data: drrResponse,
//     isLoading: isDrrLoading,
//     isError: isDrrError,
//   } = useQuery({
//     queryKey: ["dailyRecoveryReport", payload],
//     queryFn: () => getDailyRecoveryReport(payload),
//   });

//   const {
//     data: summaryResponse,
//     isLoading: isSummaryLoading,
//     isError: isSummaryError,
//   } = useQuery({
//     queryKey: ["summaryPreIntervention", lenderId],
//     queryFn: () => getSummaryPreIntervention(lenderId as string),
//     enabled: !!lenderId,
//     // staleTime: 5 * 60 * 1000, // optional: 5 min cache
//   });

//   const summary: Partial<SummaryData> = isSummaryError
//     ? {}
//     : (summaryResponse?.data as Partial<SummaryData>) ?? {};

//   const summaryFields = useMemo(() => buildSummaryFields(summary), [summary]);

//   const drrRows: DRRData[] = drrResponse?.data?.DRR ?? [];

//   return (
//     <AppLayout>
//       <Card title="Summary" className="my-5" loading={isSummaryLoading}>
//         {isSummaryError && (
//           <Alert
//             type="error"
//             showIcon
//             className="mb-4"
//             message="Could not load the pre-intervention summary."
//           />
//         )}

//         <div className="grid grid-cols-3 gap-4">
//           {summaryFields.map((field) => (
//             <LabelText key={field.label} label={field.label} text={field.value} />
//           ))}

//           <div className="flex justify-between items-end">
//             {/* TODO: wire the update modal here */}
//             <Button type="primary">Update</Button>
//           </div>
//         </div>
//       </Card>

//       <Card
//         title="DRR report"
//         extra={
//           <div className="flex gap-2">
//             <DatePicker
//               value={date}
//               format={DATE_FORMAT}
//               allowClear={false}
//               onChange={(d) => d && setDate(d)}
//             />
//             <Select
//               value={stage}
//               options={STAGE_OPTIONS}
//               onChange={setStage}
//               style={{ width: 120 }}
//             />
//           </div>
//         }
//       >
//         {isDrrError && (
//           <Alert
//             type="error"
//             showIcon
//             className="mb-4"
//             message="Could not load the daily recovery report."
//           />
//         )}

//         <Table<DRRData>
//           loading={isDrrLoading}
//           columns={drrTableColumns}
//           dataSource={drrRows}
//           rowKey={(record) => `${record.bucket}-${record.cohortName ?? ""}`}
//           size="middle"
//           pagination={false}
//           sticky
//           scroll={{ x: "max-content" }}
//         />
//       </Card>
//     </AppLayout>
//   );
// };

// export default DRR;   

import { useEffect, useMemo, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  Alert,
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Table,
  message,
} from "antd";
import type { TableColumnsType } from "antd";
import type { ColumnType } from "antd/es/table";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import axios from "axios";
import { useParams } from "react-router-dom";
import AppLayout from "../../../components/Layout";
import LabelText from "../../../components/LabelText";
import {
  getDailyRecoveryReport,
  getSummaryPreIntervention,
} from "../../../services/adminController";
import { formatRupee } from "../../../utils";

dayjs.extend(customParseFormat);

/* ----------------------------- Types ----------------------------- */

interface DRRData {
  bucket: string;
  cohortName: string | null;
  totalBorrowers: string;
  totalOSAmount: string;
  totalTargetAmount: string | null;
  forTheDay: string;
  monthTillDate: string;
  totalLogin: string;
  totalConnect1600: string;
  totalConnectNon1600: string;
  totalConnect1600Per: string;
  totalConnectNon1600Per: string;
  ptp: string;
  churn1600: string;
  churnNon1600: string;
  averageCaseResource: string;
  targetAmount: string;
  totalConnectedCallMade: string;
  agentCallMade: string;
  dialerCallMade: string;
  ivrCallMade: string;
  emailSent: string;
  smsSent: string;
  totalLegalNotice: string | null;
  todayTargetAmount: string;
  createdAt: string | null;
  updatedAt: string | null;
  ptp_1600:string | null;
}

interface SummaryData {
  lenderName: string;
  lastUpdated: string;
  totalBorrowerCount: number | string;
  totalLoanAmount: number | string;
  totalOSAmount: number | string;
  preInteOSAmount: number | string;
  preInteBorrowerCount: number | string;
  preInteLoanAmount: number | string;
  mtdTotal: number | string;
  targetAmount: number | string;
  targetAchievePer: number | string;
  nextAllocationDate: string;
  targetAmount_180_365: number | string;
  targetAmount_365_plus: number | string;
  loginCount_180_365: number | string;
  loginCount_365_plus: number | string;
  totalIvrCallMade: number | string;
  total_agent_1600_call_365_plus: number | string;
  totalAgentCall_365_plus: number | string;
  totalAgent1600_Call_180_365: number | string;
  totalAgentCall_180_365: number | string;
  ptp: number | string;
  ptp_1600: number | string | null;
}

/** Exactly what POST /v1/analysis/summary-update accepts. Nothing else is ever sent. */
interface UpdateSummaryPayload {
  loginCount_180_365: string;
  loginCount_365_plus: string;
  ptp: string;
  nextAllocationDate: string;
  target: string;
  targetAmount_180_365: string;
  targetAmount_365_plus: string;
  totalAgent1600_Call_180_365: string;
  totalAgentCall_180_365: string;
  totalAgentCall_365_plus: string;
  totalIvrCallMade: string;
  total_agent_1600_call_365_plus: string;
  ptp_1600: string;
}

/* ----------------------------- Helpers ----------------------------- */

const NA = "NA";
const DATE_FORMAT = "DD/MM/YYYY";
// TODO: replace with the real client id (route param / auth context)
const CLIENT_ID = "nbfc3";

const toNumber = (v: unknown): number | null => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
};

const rupee = (v: unknown): string => {
  const n = toNumber(v);
  return n === null ? NA : String(formatRupee(n));
};

const plain = (v: unknown): string =>
  v === null || v === undefined || v === "" ? NA : String(v);

const percent = (v: unknown): string => {
  const n = toNumber(v);
  return n === null ? NA : `${n} %`;
};

const formatDateTime = (v?: string | null) =>
  v ? dayjs(v).format("DD/MM/YYYY hh:mm:ss A") : NA;

const addDays = (v: string | null | undefined, days: number) =>
  v ? dayjs(v).add(days, "day").format(DATE_FORMAT) : NA;

/* ------------------------------ API ------------------------------ */

// NOTE: plain axios has no auth headers. If your other services use a
// configured axios instance (token / baseURL), swap it in here.
const SUMMARY_UPDATE_URL =`${process.env.REACT_APP_API_BASE_URL}/analysis/summary-update`;

const updateSummary = async (clientId: string, payload: UpdateSummaryPayload) => {
  const response = await axios.post(SUMMARY_UPDATE_URL, payload, {
    params: { clientId },
  });
  return response.data;
};

/* ------------------------- Summary fields ------------------------- */

const buildSummaryFields = (s: Partial<SummaryData>) => [
  // Basic information
  { label: "Lender Name", value: plain(s.lenderName) },
  { label: "Last Updated Date (Pre-Intervention)", value: formatDateTime(s.lastUpdated) },
  { label: "Pre-Intervention Re-Upload Date", value: addDays(s.lastUpdated, 30) },

  // Overall collection / borrower data
  { label: "Total Borrowers (All Time)", value: plain(s.totalBorrowerCount) },
  { label: "Total Original Principal (All Time)", value: rupee(s.totalLoanAmount) },
  { label: "Total Outstanding (All Time)", value: rupee(s.totalOSAmount) },
  { label: "Total Outstanding (Pre-Intervention)", value: rupee(s.preInteOSAmount) },
  { label: "Total Pre-Intervention Borrowers", value: plain(s.preInteBorrowerCount) },
  { label: "Pre-Intervention Loan Amount", value: rupee(s.preInteLoanAmount) },

  // Collection / target
  { label: "Month-to-Date (MTD) Collection", value: rupee(s.mtdTotal) },
  { label: "Monthly Target Amount", value: rupee(s.targetAmount) },
  { label: "Monthly Target Achieved", value: percent(s.targetAchievePer) },
  { label: "Next Allocation Date", value: plain(s.nextAllocationDate) },

  // Bucket-wise target
  { label: "Target Amount (180-365 Days)", value: rupee(s.targetAmount_180_365) },
  { label: "Target Amount (365+ Days)", value: rupee(s.targetAmount_365_plus) },

  // Login counts
  { label: "Login Count (180-365 Days)", value: plain(s.loginCount_180_365) },
  { label: "Login Count (365+ Days)", value: plain(s.loginCount_365_plus) },

  // Call data
  { label: "Total IVR Calls Made", value: plain(s.totalIvrCallMade) },
  { label: "Agent 1600 Calls (365+ Days)", value: plain(s.total_agent_1600_call_365_plus) },
  { label: "Agent Calls (365+ Days)", value: plain(s.totalAgentCall_365_plus) },
  { label: "Agent 1600 Calls (180-365 Days)", value: plain(s.totalAgent1600_Call_180_365) },
  { label: "Agent Calls (180-365 Days)", value: plain(s.totalAgentCall_180_365) },

  // PTP
  { label: "PTP Non 1600", value: plain(s.ptp) },
  { label: "PTP 1600", value: plain(s.ptp_1600) },
];

/* --------------------------- Table columns --------------------------- */

type ColumnKind = "text" | "amount" | "percent";

const col = (
  title: string,
  key: keyof DRRData,
  kind: ColumnKind = "text",
  width = 150
): ColumnType<DRRData> => ({
  title,
  dataIndex: key,
  key,
  width,
  align: kind === "text" ? undefined : "right",
  sorter: (a, b) => (toNumber(a[key]) ?? 0) - (toNumber(b[key]) ?? 0),
  render: (v) =>
    kind === "amount" ? rupee(v) : kind === "percent" ? percent(v) : plain(v),
});

// Defined once, outside the component, so it isn't rebuilt on every render.
const drrTableColumns: TableColumnsType<DRRData> = [
  {
    title: "Bucket",
    dataIndex: "bucket",
    key: "bucket",
    fixed: "left",
    width: 140,
    sorter: (a: DRRData, b: DRRData) => a.bucket.localeCompare(b.bucket),
  },
  col("Total Borrowers", "totalBorrowers"),
  col("Total OS Amount", "totalOSAmount", "amount", 170),
  col("Target Amount", "targetAmount", "amount", 170),
  col("Today Target Amount", "todayTargetAmount", "amount", 170),
  col("For The Day", "forTheDay", "amount"),
  col("Month Till Date", "monthTillDate", "amount"),
  col("Total Login", "totalLogin"),
  col("Connect 1600", "totalConnect1600"),
  col("Connect Non 1600", "totalConnectNon1600"),
  col("Connect 1600 %", "totalConnect1600Per", "percent"),
  col("Connect Non 1600 %", "totalConnectNon1600Per", "percent"),
    col("PTP 1600", "ptp_1600"),
  col("PTP Non 1600", "ptp"),
  col("Churn 1600", "churn1600"),
  col("Churn Non 1600", "churnNon1600"),
  col("Avg Case Resource", "averageCaseResource"),
  col("Total Connected Calls", "totalConnectedCallMade"),
  col("Agent Calls", "agentCallMade"),
  col("Dialer Calls", "dialerCallMade"),
  col("IVR Calls", "ivrCallMade"),
  col("Email Sent", "emailSent"),
  col("SMS Sent", "smsSent"),
  // col("Legal Notice", "totalLegalNotice"),
];

const STAGE_OPTIONS = [
  { value: "STAGE_1", label: "Stage 1" },
  { value: "STAGE_2", label: "Stage 2" },
  { value: "STAGE_3", label: "Stage 3" },
];

/* ------------------------ Update summary modal ------------------------ */

type FormValues = Omit<UpdateSummaryPayload, "nextAllocationDate"> & {
  nextAllocationDate: Dayjs | null;
};

type FieldKind = "count" | "amount" | "text";

interface FieldConfig {
  name: Exclude<keyof UpdateSummaryPayload, "nextAllocationDate">;
  label: string;
  kind: FieldKind;
}

const UPDATE_FIELDS: FieldConfig[] = [
  { name: "target", label: "Monthly Target Amount", kind: "amount" },
  { name: "targetAmount_180_365", label: "Target Amount (180-365 Days)", kind: "amount" },
  { name: "targetAmount_365_plus", label: "Target Amount (365+ Days)", kind: "amount" },
  { name: "loginCount_180_365", label: "Login Count (180-365 Days)", kind: "count" },
  { name: "loginCount_365_plus", label: "Login Count (365+ Days)", kind: "count" },
  { name: "totalIvrCallMade", label: "Total IVR Calls Made", kind: "count" },
  { name: "total_agent_1600_call_365_plus", label: "Agent 1600 Calls (365+ Days)", kind: "count" },
  { name: "totalAgentCall_365_plus", label: "Agent Calls Non 1600 (365+ Days)", kind: "count" },
  { name: "totalAgent1600_Call_180_365", label: "Agent 1600 Calls (180-365 Days)", kind: "count" },
  { name: "totalAgentCall_180_365", label: "Agent Calls Non 1600 (180-365 Days)", kind: "count" },
   { name: "ptp_1600", label: "PTP 1600", kind: "text" },
  { name: "ptp", label: "PTP Non 1600", kind: "text" },
 
];

const FIELD_RULES: Record<FieldKind, { pattern?: RegExp; message?: string }> = {
  count: { pattern: /^\d+$/, message: "Enter a whole number" },
  amount: { pattern: /^\d+(\.\d{1,2})?$/, message: "Enter a valid amount" },
  text: {},
};

const toStr = (v: unknown) => (v === null || v === undefined ? "" : String(v));

// The GET API may return DD/MM/YYYY or an ISO string, so try both.
const parseDate = (v?: string | null): Dayjs | null => {
  if (!v) return null;
  const strict = dayjs(v, DATE_FORMAT, true);
  if (strict.isValid()) return strict;
  const loose = dayjs(v);
  return loose.isValid() ? loose : null;
};

// GET calls the monthly target `targetAmount`; POST calls it `target`.
const toFormValues = (d: Partial<SummaryData>): FormValues => ({
  loginCount_180_365: toStr(d.loginCount_180_365),
  loginCount_365_plus: toStr(d.loginCount_365_plus),
  ptp: toStr(d.ptp),
  ptp_1600: toStr(d.ptp_1600),
  nextAllocationDate: parseDate(d.nextAllocationDate),
  target: toStr(d.targetAmount),
  targetAmount_180_365: toStr(d.targetAmount_180_365),
  targetAmount_365_plus: toStr(d.targetAmount_365_plus),
  totalAgent1600_Call_180_365: toStr(d.totalAgent1600_Call_180_365),
  totalAgentCall_180_365: toStr(d.totalAgentCall_180_365),
  totalAgentCall_365_plus: toStr(d.totalAgentCall_365_plus),
  totalIvrCallMade: toStr(d.totalIvrCallMade),
  total_agent_1600_call_365_plus: toStr(d.total_agent_1600_call_365_plus),
});

interface UpdateSummaryModalProps {
  open: boolean;
  loading?: boolean;
  initialData: Partial<SummaryData>;
  onCancel: () => void;
  onSubmit: (payload: UpdateSummaryPayload) => void;
}

const UpdateSummaryModal = ({
  open,
  loading = false,
  initialData,
  onCancel,
  onSubmit,
}: UpdateSummaryModalProps) => {
  const [form] = Form.useForm<FormValues>();

  // Autopopulate from the summary API every time the modal opens.
  useEffect(() => {
    if (open) {
      form.setFieldsValue(toFormValues(initialData));
    } else {
      form.resetFields();
    }
  }, [open, initialData, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    const { nextAllocationDate, ...rest } = values;

    const trimmed = Object.fromEntries(
      Object.entries(rest).map(([k, v]) => [k, String(v ?? "").trim()])
    ) as Omit<UpdateSummaryPayload, "nextAllocationDate">;

    onSubmit({
      ...trimmed,
      nextAllocationDate: nextAllocationDate
        ? nextAllocationDate.format(DATE_FORMAT)
        : "",
    });
  };

  return (
    <Modal
      title="Update summary"
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Save changes"
      confirmLoading={loading}
      maskClosable={false}
      width={720}
    >
      <Form form={form} layout="vertical" requiredMark={false}>
        <div className="grid grid-cols-2 gap-x-4">
          {UPDATE_FIELDS.map(({ name, label, kind }) => (
            <Form.Item
              key={name}
              name={name}
              label={label}
              rules={[
                { required: true, message: `${label} is required` },
                ...(FIELD_RULES[kind].pattern
                  ? [
                      {
                        pattern: FIELD_RULES[kind].pattern,
                        message: FIELD_RULES[kind].message,
                      },
                    ]
                  : []),
              ]}
            >
              <Input />
            </Form.Item>
          ))}

          <Form.Item
            name="nextAllocationDate"
            label="Next Allocation Date"
            rules={[{ required: true, message: "Next allocation date is required" }]}
          >
            <DatePicker format={DATE_FORMAT} className="w-full" />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

/* ----------------------------- Component ----------------------------- */

const DRR = () => {
  const { lenderId } = useParams<{ lenderId: string }>();
  const queryClient = useQueryClient();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Filters that drive the DRR request
  const [date, setDate] = useState<Dayjs>(dayjs());
  const [stage, setStage] = useState<string>("STAGE_3");

  const payload = useMemo(
    () => ({
      clientId: CLIENT_ID,
      date: date.format(DATE_FORMAT),
      stage,
      status: "ALL",
    }),
    [date, stage]
  );

  const {
    data: drrResponse,
    isLoading: isDrrLoading,
    isError: isDrrError,
  } = useQuery({
    queryKey: ["dailyRecoveryReport", payload],
    queryFn: () => getDailyRecoveryReport(payload),
  });

  const {
    data: summaryResponse,
    isLoading: isSummaryLoading,
    isError: isSummaryError,
  } = useQuery({
    queryKey: ["summaryPreIntervention", lenderId],
    queryFn: () => getSummaryPreIntervention(lenderId as string),
    enabled: !!lenderId,
    // staleTime: 5 * 60 * 1000, // optional: 5 min cache
  });

  const summary: Partial<SummaryData> = isSummaryError
    ? {}
    : (summaryResponse?.data as Partial<SummaryData>) ?? {};

  const summaryFields = useMemo(() => buildSummaryFields(summary), [summary]);

  const drrRows: DRRData[] = drrResponse?.data?.DRR ?? [];

  const updateSummaryMutation = useMutation({
    mutationFn: (values: UpdateSummaryPayload) =>
      updateSummary(lenderId as string, values),
    onSuccess: () => {
      message.success("Summary updated");
      setIsModalOpen(false);
      // Refetch so the card (and the next modal open) shows the saved values.
      queryClient.invalidateQueries({
        queryKey: ["summaryPreIntervention", lenderId],
      });
    },
    onError: () => {
      message.error("Could not update the summary. Try again.");
    },
  });

  return (
    <AppLayout>
      <Card title="Summary" className="my-5" loading={isSummaryLoading}>
        {isSummaryError && (
          <Alert
            type="error"
            showIcon
            className="mb-4"
            message="Could not load the pre-intervention summary."
          />
        )}

        <div className="grid grid-cols-3 gap-4">
          {summaryFields.map((field) => (
            <LabelText key={field.label} label={field.label} text={field.value} />
          ))}

          <div className="flex justify-between items-end">
            <Button
              type="primary"
              onClick={() => setIsModalOpen(true)}
              disabled={!lenderId || isSummaryLoading || isSummaryError}
            >
              Update Summary
            </Button>
          </div>
        </div>
      </Card>

      <Card
        title="DRR report"
        extra={
          <div className="flex gap-2">
            <DatePicker
              value={date}
              format={DATE_FORMAT}
              allowClear={false}
              onChange={(d) => d && setDate(d)}
            />
            {/* <Select
              value={stage}
              options={STAGE_OPTIONS}
              onChange={setStage}
              style={{ width: 120 }}
            /> */}
          </div>
        }
      >
        {isDrrError && (
          <Alert
            type="error"
            showIcon
            className="mb-4"
            message="Could not load the daily recovery report."
          />
        )}

        <Table<DRRData>
          loading={isDrrLoading}
          columns={drrTableColumns}
          dataSource={drrRows}
          rowKey={(record) => `${record.bucket}-${record.cohortName ?? ""}`}
          size="middle"
          pagination={false}
          sticky
          scroll={{ x: "max-content" }}
        />
      </Card>

      <UpdateSummaryModal
        open={isModalOpen}
        loading={updateSummaryMutation.isPending}
        initialData={summary}
        onCancel={() => setIsModalOpen(false)}
        onSubmit={(values) => updateSummaryMutation.mutate(values)}
      />
    </AppLayout>
  );
};

export default DRR;